import React, { useEffect, useState } from "react";
import ReactApexCharts from "react-apexcharts";
import { toMetricFormat, numberWithCommas, roundToTwoDecimalPlaces } from "../Utils/ClientUtil";
import _ from "lodash";
import palette from "theme/palette";

const BarChartNegative = (props) => {
    const [chartInit, setChartInit] = useState();
    const { xAxisTitle, colors, data, yAxisTitle, kpiName, categories, height, testControlChecked, groupView } = props;

    useEffect(() => {
        setChartInit({
            series: [{
                name: xAxisTitle,
                dataSet: data,
                data: testControlChecked && xAxisTitle === "Lift (%)"
                    ? _.map(_.sortBy(data, (v) => categories.indexOf(v.dataPointName)), "lift")
                    : testControlChecked && xAxisTitle === "Absolute Lift"
                        ? _.map(_.sortBy(data, (v) => categories.indexOf(v.dataPointName)), "abs_lift")
                        : !testControlChecked && xAxisTitle === "Lift (%)"
                            ? _.map(_.sortBy(data, (v) => categories.indexOf(v.dataPointName)), "prelift")
                            : !testControlChecked && xAxisTitle === "Absolute Lift"
                                ? _.map(_.sortBy(data, (v) => categories.indexOf(v.dataPointName)), "preAbsolutelift")
                                : []

            }],
            options: {
                chart: {
                    type: 'bar'
                },
                tooltip: {
                    custom: function ({ seriesIndex, dataPointIndex, w }) {
                        const selectedData = w.globals.labels[dataPointIndex]
                        const finalDataSet = data?.find(item => item.dataPointName === selectedData)
                        return testControlChecked && groupView && kpiName === "responder_rate" ? '<ul style="padding: 10px; list-style: none">' +
                            '<li style="font-size: 12px">' + finalDataSet?.dataPointName + '</li>' +
                            '<li style="font-size: 12px">Lift% : ' + finalDataSet?.lift + '%' + '</li>' +
                            '<li style="font-size: 12px">Absolute Lift : ' + numberWithCommas(parseFloat(finalDataSet?.abs_lift)?.toFixed(0)) + '</li>' +
                            '<li style="font-size: 12px">Significance p-value : ' + roundToTwoDecimalPlaces (finalDataSet?.stat_sig) + '</li>' +
                            '</ul>'
                            : testControlChecked ? '<ul style="padding: 10px; list-style: none">' +
                                '<li style="font-size: 12px">' + finalDataSet?.dataPointName + '</li>' +
                                '<li style="font-size: 12px">Lift% : ' + finalDataSet?.lift + '%' + '</li>' +
                                '<li style="font-size: 12px">Absolute Lift : ' + toMetricFormat(parseFloat(finalDataSet?.abs_lift), kpiName) + '</li>' +
                                '<li style="font-size: 12px">Significance p-value : ' + roundToTwoDecimalPlaces (finalDataSet?.stat_sig) + '</li>' +
                                '</ul>'
                                : '<ul style="padding: 10px; list-style: none">' +
                                '<li style="font-size: 12px">' + finalDataSet?.dataPointName + '</li>' +
                                '<li style="font-size: 12px">Lift% : ' + finalDataSet?.prelift + '%' + '</li>' +
                                '<li style="font-size: 12px">Absolute Lift : ' + toMetricFormat(parseFloat(finalDataSet?.preAbsolutelift), kpiName) + '</li>' +
                                '<li style="font-size: 12px">Significance p-value : ' + roundToTwoDecimalPlaces (finalDataSet?.stat_sig) + '</li>' +
                                '</ul>';
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '40px',
                        // dataLabels: {
                        //     position: 'top'
                        // }
                    }
                },
                colors: colors ? colors : [function (opt) {
                    const selectedData = opt.w.globals.labels[opt.dataPointIndex]
                    const finalDataSet = data?.find(item => item.dataPointName === selectedData)
                    if (finalDataSet?.stat_sig === null) {
                        return palette.semanticBGColors.primaryRed
                    } else if (finalDataSet?.stat_sig < 0.05) {
                        return palette.semanticBGColors.primaryGreen
                    } else if (finalDataSet?.stat_sig > 0.2) {
                        return palette.semanticBGColors.primaryRed
                    } else {
                        return palette.semanticBGColors.primaryYellow
                    }
                }],
                stroke: {
                    width: [0, 4],
                    curve: 'smooth'
                },
                title: {
                    text: xAxisTitle
                },
                grid: {
                    show: false,
                    position: 'back',
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                dataLabels: {
                    enabled: true,
                    // offsetX: 45,
                    formatter: function (val) {
                        if (xAxisTitle === "Lift (%)") {
                            return val + "%"
                        }
                        else {
                            return toMetricFormat(val, kpiName)
                        }
                    },
                    style: {
                        colors: [palette.text.dark]
                    }
                },
                yaxis: {
                    title: {
                        text: yAxisTitle,
                    },
                },
                xaxis: {
                    tickAmount: 4,
                    title: {
                        text: xAxisTitle,
                    },
                    categories: categories ? categories : _.map(data, "dataPointName"),

                }
            },
        });
    }, [categories,height,colors,data,groupView,kpiName,testControlChecked,xAxisTitle,yAxisTitle]);

    return (
        <>
            {chartInit && (
                <>
                    <ReactApexCharts
                        options={chartInit?.options}
                        series={chartInit?.series}
                        type="bar"
                        height={data?.length < 5 ? 300 : data?.length * 70}
                    />
                </>
            )}
        </>
    );
};
export default BarChartNegative;